<template>
  <div>
    <div class="banner-bl">
      <div class="banner-content">
        <span class="banner-title">专辑列表</span>
        <span class="total_numbers-wrap" v-if="totalNumber">
          <span class="total_numbers">{{ totalNumber }} +</span> 个精彩演讲视频
        </span>
      </div>
    </div>
    <div class="content">
      <div class="albums-title">
        专辑
      </div>
      <div class="tabs-bl">
        <div class="sort-tabs">
          <div class="tab-item" :class="{ active: activeSortTab === 1 }" @click="onClickSort(1)">
            <span class="tab-content">按发布时间排序<i class="iconfont iconarrow" :class="{ isUp: sortTabStatus[1] }"></i></span>
          </div>
          <div class="tab-item" :class="{ active: activeSortTab === 2 }" @click="onClickSort(2)">
            <span slot="label" class="tab-content">按播放量排序<i class="iconfont iconarrow" :class="{ isUp: sortTabStatus[2] }"></i></span>
          </div>
          <div class="tab-bottom-active-line" :class="[activeSortTab === 1 ? 'left' : 'right']"></div>
        </div>
      </div>
      <div class="albums">
        <div class="album-item-wrap" v-for="item in albums" :key="item.id" @click="openAlbum(item)">
          <div class="album-item">
            <div class="album_cover">
              <img class="album_cover-img" :src="item.cover" alt="" srcset="" />
              <div class="shadow"></div>
            </div>
            <div class="album_info">
              <span class="album_title">{{ item.title }}</span>
              <span class="album_numbers">{{ item.count }}个演讲</span>
            </div>
          </div>
          <p class="album_intro">{{ item.intro }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import requestApi from '@/service';

export default {
  data() {
    return {
      totalNumber: 0,
      activeSortTab: 1,
      sortTabStatus: {
        1: false,
        2: false,
      },
      albums: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path !== '/speech/album/detail') {
        vm.initData();
        vm.initScrollTop();
      }
    });
  },
  methods: {
    initData() {
      this.activeSortTab = 1;
      this.getTotalNumber();
      this.getAlbums();
    },
    onClickSort(val) {
      if (this.activeSortTab === val) {
        if (this.sortClickTimer) {
          return;
        }
        this.sortTabStatus[val] = !this.sortTabStatus[val];
        this.sortClickTimer = setTimeout(() => {
          this.sortClickTimer = null;
        }, 500);
      } else {
        this.activeSortTab = val;
      }
      this.getAlbums();
    },
    /**
     * @description: 获取演讲总数
     */
    getTotalNumber() {
      requestApi('/v3/api/site/speech/total/').then(res => {
        this.totalNumber = res.total;
      });
    },
    getAlbums() {
      requestApi('/v3/api/site/album/', {
        order_by: this.getSort(),
      }).then(({ items }) => {
        this.albums = items;
      });
    },
    /**
     * @description: 0发布时间倒序 1发布时间正序 2播放量倒序 3播放量正序
     */
    getSort() {
      let res = 0;
      if (this.activeSortTab === 1) {
        res = this.sortTabStatus[this.activeSortTab] ? 1 : 0;
      } else if (this.activeSortTab === 2) {
        res = this.sortTabStatus[this.activeSortTab] ? 3 : 2;
      }
      return res;
    },
    /**
     * @description: 打开专辑
     */
    openAlbum(item) {
      this.$router.push({
        path: '/speech/album/detail',
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-bl {
  height: 260px;
  width: 100%;
  background: url('../assets/imgs/speech-bg.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  box-sizing: border-box;
  .banner-content {
    width: 80%;
    height: 100%;
    margin: 0 auto;
    max-width: 1140px;
    color: $C1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .banner-title {
      font-size: 47px;
      margin: 0;
      line-height: 1.5;
      letter-spacing: 3px;
      font-family: HYXinRenWenSongW;
    }
    .total_numbers-wrap {
      font-size: 16px;
      line-height: 1.5;
      font-weight: 300;
      letter-spacing: 2px;
      .total_numbers {
        padding: 3px 10px;
        color: $C1;
        background: $C2;
        font-size: 18px;
        letter-spacing: 0.32px;
        font-weight: 400;
      }
    }
  }
}
.content {
  padding: 50px;
}
.albums-title {
  padding: 22px 0;
  font-size: 22px;
  font-weight: 400;
  font-family: HYXinRenWenSongW;
  text-align: left;
}
.tabs-bl {
  text-align: right;
  width: 100%;
  border-bottom: 1px solid #e7e7e7;
  margin-bottom: 30px;
  .sort-tabs {
    display: inline-flex;
    align-items: center;
    position: relative;
    width: 340px;
    .tab-item {
      flex: 1;
      font-size: 12px;
      cursor: pointer;
      color: $C9;
      padding-bottom: 20px;
      position: relative;
      user-select: none;
      white-space: nowrap;
      text-align: center;
      .iconfont {
        color: $C3;
        position: absolute;
        right: 15px;
        display: inline-block;
        transition: transform 0.3s ease-out;
        &.isUp {
          transform: rotate(-180deg);
        }
      }
      &:hover,
      &.active {
        color: $C7;
      }
    }
    .tab-bottom-active-line {
      position: absolute;
      bottom: -2px;
      width: 32px;
      height: 2px;
      background-color: $C7;
      transform: translateX(-50%);
      transition: left 0.3s ease;
      &.left {
        left: 25%;
      }
      &.right {
        left: 75%;
      }
    }
  }
}
.albums {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 25%);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  .album-item-wrap {
    .album_intro {
      height: 62px;
      color: $C9;
      font-size: 14px;
      line-height: 1.5;
      overflow: hidden;
      font-weight: 300;
      max-width: 214px;
    }
  }
  .album-item {
    position: relative;
    box-sizing: border-box;
    max-width: 214px;
    height: 290px;
    overflow: hidden;
    border-radius: 3px;
    transition: box-shadow 0.4s linear;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 20px $A1;
    }
    .album_cover {
      height: 100%;
      width: 100%;
      position: relative;
    }
    .album_info {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      color: $C1;
      padding: 20px;
      box-sizing: border-box;
      z-index: 10;
      .album_title {
        display: block;
        padding: 5px 0;
        font-size: 17px;
        line-height: 1.4;
        font-weight: bold;
        font-family: HYXinRenWenSongW;
      }
      .album_numbers {
        display: block;
        font-size: 12px;
      }
    }
  }
}
</style>
